import PropTypes from "prop-types";
import QuantityInput from "../../quantityInput/QuantityInput";
import { QuantityStyled, Container, Text } from "./Quantity.styled";

function Quantity({ id }) {
    const name = id ? `${id}.quantity` : "quantity";
    return (
        <QuantityStyled>
            <Container htmlFor={name}>
                <Text>Aantal:</Text>
                <QuantityInput name={name} hasMinimum />
            </Container>
        </QuantityStyled>
    );
}

Quantity.defaultProps = {
    id: undefined
};

Quantity.propTypes = {
    id: PropTypes.string
};

export default Quantity;
